var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import DataStoreAbi from '../../../../abis/DataStore.json';
import ERC20_ABI from '../../../../abis/erc20.json';
import exchangeRouterAbi from '../../../../abis/gmx.json';
import MulticallAbi from '../../../../abis/GMX_Multicall.json';
import SyntheticsReaderAbi from '../../../../abis/syntheticsReader.json';
import { BigNumber, ethers } from 'ethers';
import { Config } from '../../../../Fct/Config';
import { BASIS_POINTS_DIVISOR, MAX_ALLOWED_LEVERAGE, NATIVE_TOKEN_ADDRESS, USD_DECIMALS, } from '../constants';
import { GetMarkets } from '../getters/GetMarkets';
import { DecreasePositionSwapType, OrderType, TradeMode, TradeType, } from '../types';
import { accountPositionListKey, applyAcceptablePrice, applySlippageToMinOut, applySlippageToPrice, convertToContractPrice, convertTokenAddress, convertToTokenAmount, convertToUsd, createSwapEstimator, estimateCollateralCost, estimateExecuteDecreaseOrderGasLimit, estimateExecuteIncreaseOrderGasLimit, expandDecimals, fetchTickers, findAllPaths, formatAmountFree, getAvailabeTokenData, getBasisPoints, getBestSwapPath, getByKey, getContract, getContractMarketPrices, getEntryPrice, getExecutionFee, getIncreasePositionAmounts, getIsEquivalentTokens, getIsFullClose, getIsUnwrap, getIsWrap, getKeysAndPricesParams, getLeverage, getLiquidationPrice, getMarketFullName, getMarketsGraph, getMarkPrice, getMaxSwapPathLiquidity, getOptimisticPositions, getOrderInfo, getPositionFee, getPositionKey, getPositionNetValue, getPositionPendingFeesUsd, getPositionPnlUsd, getPriceImpactForPosition, getSwapAmountsByFromValue, getSwapPathStats, getSwapStats, getToken, getTokensMap, getTradeFees, getTradeFlags, getV2Tokens, getWrappedToken, isMarketOrderType, isVisibleOrder, MIN_COLLATERAL_USD_KEY, MIN_POSITION_SIZE_USD_KEY, parseOraclePrice, parseValue, payForCollateralCost, roundUpDivision, } from '../utils';
import { accountOrderListKey, borrowingExponentFactorKey, borrowingFactorKey, claimableFundingAmountKey, decreaseOrderGasLimitKey, depositGasLimitKey, ESTIMATED_GAS_FEE_BASE_AMOUNT, ESTIMATED_GAS_FEE_MULTIPLIER_FACTOR, fundingExponentFactorKey, fundingFactorKey, increaseOrderGasLimitKey, isMarketDisabledKey, MAX_PNL_FACTOR_FOR_TRADERS_KEY, maxPnlFactorKey, maxPoolAmountKey, maxPositionImpactFactorForLiquidationsKey, maxPositionImpactFactorKey, minCollateralFactorForOpenInterest, minCollateralFactorKey, openInterestInTokensKey, openInterestKey, openInterestReserveFactorKey, poolAmountAdjustmentKey, poolAmountKey, positionFeeFactorKey, positionImpactExponentFactorKey, positionImpactFactorKey, positionImpactPoolAmountKey, reserveFactorKey, singleSwapGasLimitKey, swapFeeFactorKey, swapImpactExponentFactorKey, swapImpactFactorKey, swapImpactPoolAmountKey, swapOrderGasLimitKey, virtualMarketIdKey, virtualTokenIdKey, withdrawalGasLimitKey, } from './dataStore';
import { runMulticall } from './multicall';
var AddressZero = ethers.constants.AddressZero;
var DEFAULT_COUNT = 1000;
var ALLOWED_SLIPPAGE = 30;
var GMXHelper = /** @class */ (function (_super) {
    __extends(GMXHelper, _super);
    function GMXHelper() {
        var _this = _super.apply(this, __spreadArray([], __read(arguments), false)) || this;
        _this.getMarketsData = function () { return __awaiter(_this, void 0, void 0, function () {
            var chainId, getMarkets, res, marketData, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        chainId = String(this.chainId);
                        if (chainId === '1') {
                            console.error('unsupported chain');
                            return [2 /*return*/];
                        }
                        getMarkets = new GetMarkets({
                            chainId: String(this.chainId),
                            initParams: {
                                methodParams: {
                                    dataStore: getContract({ chainId: this.chainId, name: 'DataStore' }),
                                    start: '0',
                                    end: '100',
                                },
                            },
                        });
                        if (!this.signer) {
                            console.error('signer not set');
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, getMarkets.getOutputValues({ provider: { provider: this.library, signer: this.signer } })];
                    case 1:
                        res = _a.sent();
                        try {
                            if (typeof res !== 'object')
                                return [2 /*return*/];
                            if (!('marketData_tuple[]' in res))
                                return [2 /*return*/];
                            marketData = res['marketData_tuple[]'];
                            data = marketData.reduce(function (acc, marketValues) {
                                try {
                                    var indexToken = getToken(Number(chainId), convertTokenAddress(Number(chainId), marketValues.indexToken, 'native'));
                                    var longToken = getToken(Number(chainId), marketValues.longToken);
                                    var shortToken = getToken(Number(chainId), marketValues.shortToken);
                                    var isSameCollaterals = marketValues.longToken === marketValues.shortToken;
                                    var isSpotOnly = marketValues.indexToken === ethers.constants.AddressZero;
                                    var name_1 = getMarketFullName({ indexToken: indexToken, longToken: longToken, shortToken: shortToken, isSpotOnly: isSpotOnly });
                                    acc.marketsData[marketValues.marketToken] = {
                                        marketTokenAddress: marketValues.marketToken,
                                        indexTokenAddress: marketValues.indexToken,
                                        longTokenAddress: marketValues.longToken,
                                        shortTokenAddress: marketValues.shortToken,
                                        isSameCollaterals: isSameCollaterals,
                                        isSpotOnly: isSpotOnly,
                                        name: name_1,
                                        data: '',
                                    };
                                    acc.marketsAddresses.push(marketValues.marketToken);
                                }
                                catch (e) {
                                    // eslint-disable-next-line no-console
                                    console.warn('unsupported market', e);
                                }
                                return acc;
                            }, { marketsData: {}, marketsAddresses: [] });
                            return [2 /*return*/, data];
                        }
                        catch (e) {
                            console.error(e);
                            return [2 /*return*/, undefined];
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        _this.getTokenBalances = function () { return __awaiter(_this, void 0, void 0, function () {
            var data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, runMulticall(this.chainId, 'useTokenBalances', this.library, {
                            key: this.account ? [this.account] : null,
                            request: function () {
                                return getV2Tokens(_this.chainId).reduce(function (acc, token) {
                                    // Skip synthetic tokens
                                    if (token.isSynthetic)
                                        return acc;
                                    var address = token.value;
                                    if (address === NATIVE_TOKEN_ADDRESS) {
                                        acc[address] = {
                                            contractAddress: getContract({ chainId: _this.chainId, name: 'Multicall' }),
                                            abi: MulticallAbi,
                                            calls: {
                                                balance: {
                                                    methodName: 'getEthBalance',
                                                    params: [_this.account],
                                                },
                                            },
                                        };
                                    }
                                    else {
                                        acc[address] = {
                                            contractAddress: address,
                                            abi: ERC20_ABI,
                                            calls: {
                                                balance: {
                                                    methodName: 'balanceOf',
                                                    params: [_this.account],
                                                },
                                            },
                                        };
                                    }
                                    return acc;
                                }, {});
                            },
                            parseResponse: function (res) {
                                return Object.keys(res.data).reduce(function (tokenBalances, tokenAddress) {
                                    tokenBalances[tokenAddress] = BigNumber.from(res.data[tokenAddress].balance.returnValues[0]);
                                    return tokenBalances;
                                }, {});
                            },
                        })];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, {
                                balancesData: data,
                            }];
                }
            });
        }); };
        _this.getTokenRecentPrices = function () { return __awaiter(_this, void 0, void 0, function () {
            var res;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetchTickers(this.chainId).then(function (priceItems) {
                            var result = {};
                            priceItems.forEach(function (priceItem) {
                                var tokenConfig;
                                try {
                                    tokenConfig = getToken(_this.chainId, priceItem.tokenAddress);
                                }
                                catch (e) {
                                    // ignore unknown token errors
                                    return;
                                }
                                result[tokenConfig.value] = {
                                    minPrice: parseOraclePrice(priceItem.minPrice, tokenConfig.decimals, priceItem.oracleDecimals),
                                    maxPrice: parseOraclePrice(priceItem.maxPrice, tokenConfig.decimals, priceItem.oracleDecimals),
                                };
                            });
                            var stableTokens = getV2Tokens(_this.chainId).filter(function (token) { return token.isStable; });
                            stableTokens.forEach(function (token) {
                                if (!result[token.value]) {
                                    result[token.value] = {
                                        minPrice: expandDecimals(1, 30),
                                        maxPrice: expandDecimals(1, 30),
                                    };
                                }
                            });
                            var wrappedToken = getWrappedToken(_this.chainId);
                            if (result[wrappedToken.value] && !result[NATIVE_TOKEN_ADDRESS]) {
                                result[NATIVE_TOKEN_ADDRESS] = result[wrappedToken.value];
                            }
                            return {
                                pricesData: result,
                                updatedAt: Date.now(),
                            };
                        })];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res];
                }
            });
        }); };
        _this.getTokensData = function () { return __awaiter(_this, void 0, void 0, function () {
            var tokenConfigs, balancesData, _a, pricesData, pricesUpdatedAt, tokenAddresses;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        tokenConfigs = getTokensMap(this.chainId);
                        return [4 /*yield*/, this.getTokenBalances()];
                    case 1:
                        balancesData = (_b.sent()).balancesData;
                        return [4 /*yield*/, this.getTokenRecentPrices()];
                    case 2:
                        _a = _b.sent(), pricesData = _a.pricesData, pricesUpdatedAt = _a.updatedAt;
                        tokenAddresses = getV2Tokens(this.chainId).map(function (token) { return token.value; });
                        if (!pricesData) {
                            return [2 /*return*/, {
                                    tokensData: undefined,
                                    pricesUpdatedAt: undefined,
                                }];
                        }
                        return [2 /*return*/, {
                                tokensData: tokenAddresses.reduce(function (acc, tokenAddress) {
                                    var prices = pricesData[tokenAddress];
                                    var balance = balancesData === null || balancesData === void 0 ? void 0 : balancesData[tokenAddress];
                                    var tokenConfig = tokenConfigs[tokenAddress];
                                    if (!prices) {
                                        return acc;
                                    }
                                    acc[tokenAddress] = __assign(__assign({}, tokenConfig), { prices: prices, balance: balance });
                                    return acc;
                                }, {}),
                                pricesUpdatedAt: pricesUpdatedAt,
                            }];
                }
            });
        }); };
        _this.getMarketsInfo = function () { return __awaiter(_this, void 0, void 0, function () {
            var account, markets, marketsData, marketsAddresses, dataStoreAddress, _a, tokensData, pricesUpdatedAt, res;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        account = this.account;
                        return [4 /*yield*/, this.getMarketsData()];
                    case 1:
                        markets = _b.sent();
                        if (!markets)
                            return [2 /*return*/];
                        marketsData = markets.marketsData, marketsAddresses = markets.marketsAddresses;
                        dataStoreAddress = getContract({ chainId: this.chainId, name: 'DataStore' });
                        return [4 /*yield*/, this.getTokensData()];
                    case 2:
                        _a = _b.sent(), tokensData = _a.tokensData, pricesUpdatedAt = _a.pricesUpdatedAt;
                        return [4 /*yield*/, runMulticall(this.chainId, 'useMarketsInfo', this.library, {
                                key: marketsAddresses.length > 0 && [marketsAddresses.join('-'), dataStoreAddress, account, pricesUpdatedAt],
                                // Refreshed on every prices update
                                refreshInterval: null,
                                clearUnusedKeys: true,
                                keepPreviousData: true,
                                request: function () {
                                    return marketsAddresses.reduce(function (request, marketAddress) {
                                        var _a;
                                        var market = getByKey(marketsData, marketAddress);
                                        var marketPrices = getContractMarketPrices(tokensData, market);
                                        if (!marketPrices) {
                                            return request;
                                        }
                                        var marketProps = {
                                            marketToken: market.marketTokenAddress,
                                            indexToken: market.indexTokenAddress,
                                            longToken: market.longTokenAddress,
                                            shortToken: market.shortTokenAddress,
                                        };
                                        return Object.assign(request, (_a = {},
                                            _a["".concat(marketAddress, "-reader")] = {
                                                contractAddress: getContract({ chainId: _this.chainId, name: 'SyntheticsReader' }),
                                                abi: SyntheticsReaderAbi,
                                                calls: {
                                                    marketInfo: {
                                                        methodName: 'getMarketInfo',
                                                        params: [dataStoreAddress, marketPrices, marketAddress],
                                                    },
                                                    marketTokenPriceMax: {
                                                        methodName: 'getMarketTokenPrice',
                                                        params: [
                                                            dataStoreAddress,
                                                            marketProps,
                                                            marketPrices.indexTokenPrice,
                                                            marketPrices.longTokenPrice,
                                                            marketPrices.shortTokenPrice,
                                                            MAX_PNL_FACTOR_FOR_TRADERS_KEY,
                                                            true,
                                                        ],
                                                    },
                                                    marketTokenPriceMin: {
                                                        methodName: 'getMarketTokenPrice',
                                                        params: [
                                                            dataStoreAddress,
                                                            marketProps,
                                                            marketPrices.indexTokenPrice,
                                                            marketPrices.longTokenPrice,
                                                            marketPrices.shortTokenPrice,
                                                            MAX_PNL_FACTOR_FOR_TRADERS_KEY,
                                                            false,
                                                        ],
                                                    },
                                                },
                                            },
                                            _a["".concat(marketAddress, "-dataStore")] = {
                                                contractAddress: dataStoreAddress,
                                                abi: DataStoreAbi,
                                                calls: {
                                                    isDisabled: {
                                                        methodName: 'getBool',
                                                        params: [isMarketDisabledKey(marketAddress)],
                                                    },
                                                    longPoolAmount: {
                                                        methodName: 'getUint',
                                                        params: [poolAmountKey(marketAddress, market.longTokenAddress)],
                                                    },
                                                    shortPoolAmount: {
                                                        methodName: 'getUint',
                                                        params: [poolAmountKey(marketAddress, market.shortTokenAddress)],
                                                    },
                                                    maxLongPoolAmount: {
                                                        methodName: 'getUint',
                                                        params: [maxPoolAmountKey(marketAddress, market.longTokenAddress)],
                                                    },
                                                    maxShortPoolAmount: {
                                                        methodName: 'getUint',
                                                        params: [maxPoolAmountKey(marketAddress, market.shortTokenAddress)],
                                                    },
                                                    longPoolAmountAdjustment: {
                                                        methodName: 'getUint',
                                                        params: [poolAmountAdjustmentKey(marketAddress, market.longTokenAddress)],
                                                    },
                                                    shortPoolAmountAdjustment: {
                                                        methodName: 'getUint',
                                                        params: [poolAmountAdjustmentKey(marketAddress, market.longTokenAddress)],
                                                    },
                                                    reserveFactorLong: {
                                                        methodName: 'getUint',
                                                        params: [reserveFactorKey(marketAddress, true)],
                                                    },
                                                    reserveFactorShort: {
                                                        methodName: 'getUint',
                                                        params: [reserveFactorKey(marketAddress, true)],
                                                    },
                                                    openInterestReserveFactorLong: {
                                                        methodName: 'getUint',
                                                        params: [openInterestReserveFactorKey(marketAddress, true)],
                                                    },
                                                    openInterestReserveFactorShort: {
                                                        methodName: 'getUint',
                                                        params: [openInterestReserveFactorKey(marketAddress, false)],
                                                    },
                                                    positionImpactPoolAmount: {
                                                        methodName: 'getUint',
                                                        params: [positionImpactPoolAmountKey(marketAddress)],
                                                    },
                                                    swapImpactPoolAmountLong: {
                                                        methodName: 'getUint',
                                                        params: [swapImpactPoolAmountKey(marketAddress, market.longTokenAddress)],
                                                    },
                                                    swapImpactPoolAmountShort: {
                                                        methodName: 'getUint',
                                                        params: [swapImpactPoolAmountKey(marketAddress, market.shortTokenAddress)],
                                                    },
                                                    borrowingFactorLong: {
                                                        methodName: 'getUint',
                                                        params: [borrowingFactorKey(marketAddress, true)],
                                                    },
                                                    borrowingFactorShort: {
                                                        methodName: 'getUint',
                                                        params: [borrowingFactorKey(marketAddress, false)],
                                                    },
                                                    borrowingExponentFactorLong: {
                                                        methodName: 'getUint',
                                                        params: [borrowingExponentFactorKey(marketAddress, true)],
                                                    },
                                                    borrowingExponentFactorShort: {
                                                        methodName: 'getUint',
                                                        params: [borrowingExponentFactorKey(marketAddress, false)],
                                                    },
                                                    fundingFactor: {
                                                        methodName: 'getUint',
                                                        params: [fundingFactorKey(marketAddress)],
                                                    },
                                                    fundingExponentFactor: {
                                                        methodName: 'getUint',
                                                        params: [fundingExponentFactorKey(marketAddress)],
                                                    },
                                                    maxPnlFactorForTradersLong: {
                                                        methodName: 'getUint',
                                                        params: [maxPnlFactorKey(MAX_PNL_FACTOR_FOR_TRADERS_KEY, marketAddress, true)],
                                                    },
                                                    maxPnlFactorForTradersShort: {
                                                        methodName: 'getUint',
                                                        params: [maxPnlFactorKey(MAX_PNL_FACTOR_FOR_TRADERS_KEY, marketAddress, false)],
                                                    },
                                                    claimableFundingAmountLong: account
                                                        ? {
                                                            methodName: 'getUint',
                                                            params: [claimableFundingAmountKey(marketAddress, market.longTokenAddress, account)],
                                                        }
                                                        : undefined,
                                                    claimableFundingAmountShort: account
                                                        ? {
                                                            methodName: 'getUint',
                                                            params: [claimableFundingAmountKey(marketAddress, market.shortTokenAddress, account)],
                                                        }
                                                        : undefined,
                                                    positionFeeFactorForPositiveImpact: {
                                                        methodName: 'getUint',
                                                        params: [positionFeeFactorKey(marketAddress, true)],
                                                    },
                                                    positionFeeFactorForNegativeImpact: {
                                                        methodName: 'getUint',
                                                        params: [positionFeeFactorKey(marketAddress, false)],
                                                    },
                                                    positionImpactFactorPositive: {
                                                        methodName: 'getUint',
                                                        params: [positionImpactFactorKey(marketAddress, true)],
                                                    },
                                                    positionImpactFactorNegative: {
                                                        methodName: 'getUint',
                                                        params: [positionImpactFactorKey(marketAddress, false)],
                                                    },
                                                    maxPositionImpactFactorPositive: {
                                                        methodName: 'getUint',
                                                        params: [maxPositionImpactFactorKey(marketAddress, true)],
                                                    },
                                                    maxPositionImpactFactorNegative: {
                                                        methodName: 'getUint',
                                                        params: [maxPositionImpactFactorKey(marketAddress, false)],
                                                    },
                                                    maxPositionImpactFactorForLiquidations: {
                                                        methodName: 'getUint',
                                                        params: [maxPositionImpactFactorForLiquidationsKey(marketAddress)],
                                                    },
                                                    minCollateralFactor: {
                                                        methodName: 'getUint',
                                                        params: [minCollateralFactorKey(marketAddress)],
                                                    },
                                                    minCollateralFactorForOpenInterestLong: {
                                                        methodName: 'getUint',
                                                        params: [minCollateralFactorForOpenInterest(marketAddress, true)],
                                                    },
                                                    minCollateralFactorForOpenInterestShort: {
                                                        methodName: 'getUint',
                                                        params: [minCollateralFactorForOpenInterest(marketAddress, false)],
                                                    },
                                                    positionImpactExponentFactor: {
                                                        methodName: 'getUint',
                                                        params: [positionImpactExponentFactorKey(marketAddress)],
                                                    },
                                                    swapFeeFactorForPositiveImpact: {
                                                        methodName: 'getUint',
                                                        params: [swapFeeFactorKey(marketAddress, true)],
                                                    },
                                                    swapFeeFactorForNegativeImpact: {
                                                        methodName: 'getUint',
                                                        params: [swapFeeFactorKey(marketAddress, false)],
                                                    },
                                                    swapImpactFactorPositive: {
                                                        methodName: 'getUint',
                                                        params: [swapImpactFactorKey(marketAddress, true)],
                                                    },
                                                    swapImpactFactorNegative: {
                                                        methodName: 'getUint',
                                                        params: [swapImpactFactorKey(marketAddress, false)],
                                                    },
                                                    swapImpactExponentFactor: {
                                                        methodName: 'getUint',
                                                        params: [swapImpactExponentFactorKey(marketAddress)],
                                                    },
                                                    longInterestUsingLongToken: {
                                                        methodName: 'getUint',
                                                        params: [openInterestKey(marketAddress, market.longTokenAddress, true)],
                                                    },
                                                    longInterestUsingShortToken: {
                                                        methodName: 'getUint',
                                                        params: [openInterestKey(marketAddress, market.shortTokenAddress, true)],
                                                    },
                                                    shortInterestUsingLongToken: {
                                                        methodName: 'getUint',
                                                        params: [openInterestKey(marketAddress, market.longTokenAddress, false)],
                                                    },
                                                    shortInterestUsingShortToken: {
                                                        methodName: 'getUint',
                                                        params: [openInterestKey(marketAddress, market.shortTokenAddress, false)],
                                                    },
                                                    longInterestInTokensUsingLongToken: {
                                                        methodName: 'getUint',
                                                        params: [openInterestInTokensKey(marketAddress, market.longTokenAddress, true)],
                                                    },
                                                    longInterestInTokensUsingShortToken: {
                                                        methodName: 'getUint',
                                                        params: [openInterestInTokensKey(marketAddress, market.shortTokenAddress, true)],
                                                    },
                                                    shortInterestInTokensUsingLongToken: {
                                                        methodName: 'getUint',
                                                        params: [openInterestInTokensKey(marketAddress, market.longTokenAddress, false)],
                                                    },
                                                    shortInterestInTokensUsingShortToken: {
                                                        methodName: 'getUint',
                                                        params: [openInterestInTokensKey(marketAddress, market.shortTokenAddress, false)],
                                                    },
                                                    virtualMarketId: {
                                                        methodName: 'getBytes32',
                                                        params: [virtualMarketIdKey(marketAddress)],
                                                    },
                                                    virtualLongTokenId: {
                                                        methodName: 'getBytes32',
                                                        params: [virtualTokenIdKey(market.longTokenAddress)],
                                                    },
                                                    virtualShortTokenId: {
                                                        methodName: 'getBytes32',
                                                        params: [virtualTokenIdKey(market.shortTokenAddress)],
                                                    },
                                                },
                                            },
                                            _a));
                                    }, {});
                                },
                                parseResponse: function (res) {
                                    return marketsAddresses.reduce(function (acc, marketAddress) {
                                        var _a, _b;
                                        var readerErrors = res.errors["".concat(marketAddress, "-reader")];
                                        var dataStoreErrors = res.errors["".concat(marketAddress, "-dataStore")];
                                        var readerValues = res.data["".concat(marketAddress, "-reader")];
                                        var dataStoreValues = res.data["".concat(marketAddress, "-dataStore")];
                                        // Skip invalid market
                                        if (!readerValues || !dataStoreValues || readerErrors || dataStoreErrors) {
                                            return acc;
                                        }
                                        var longInterestUsingLongToken = BigNumber.from(dataStoreValues.longInterestUsingLongToken.returnValues[0]);
                                        var longInterestUsingShortToken = BigNumber.from(dataStoreValues.longInterestUsingShortToken.returnValues[0]);
                                        var shortInterestUsingLongToken = BigNumber.from(dataStoreValues.shortInterestUsingLongToken.returnValues[0]);
                                        var shortInterestUsingShortToken = BigNumber.from(dataStoreValues.shortInterestUsingShortToken.returnValues[0]);
                                        var longInterestUsd = longInterestUsingLongToken.add(longInterestUsingShortToken);
                                        var shortInterestUsd = shortInterestUsingLongToken.add(shortInterestUsingShortToken);
                                        var longInterestInTokensUsingLongToken = BigNumber.from(dataStoreValues.longInterestInTokensUsingLongToken.returnValues[0]);
                                        var longInterestInTokensUsingShortToken = BigNumber.from(dataStoreValues.longInterestInTokensUsingShortToken.returnValues[0]);
                                        var shortInterestInTokensUsingLongToken = BigNumber.from(dataStoreValues.shortInterestInTokensUsingLongToken.returnValues[0]);
                                        var shortInterestInTokensUsingShortToken = BigNumber.from(dataStoreValues.shortInterestInTokensUsingShortToken.returnValues[0]);
                                        var longInterestInTokens = longInterestInTokensUsingLongToken.add(longInterestInTokensUsingShortToken);
                                        var shortInterestInTokens = shortInterestInTokensUsingLongToken.add(shortInterestInTokensUsingShortToken);
                                        // eslint-disable-next-line @typescript-eslint/no-unused-vars
                                        var _c = readerValues.marketInfo.returnValues, nextFunding = _c.nextFunding, virtualInventory = _c.virtualInventory;
                                        // eslint-disable-next-line @typescript-eslint/no-unused-vars
                                        var _d = __read(readerValues.marketTokenPriceMin.returnValues, 2), _priceMin = _d[0], poolValueInfoMin = _d[1];
                                        // eslint-disable-next-line @typescript-eslint/no-unused-vars
                                        var _e = __read(readerValues.marketTokenPriceMax.returnValues, 2), _priceMax = _e[0], poolValueInfoMax = _e[1];
                                        var market = getByKey(marketsData, marketAddress);
                                        var longToken = getByKey(tokensData, market.longTokenAddress);
                                        var shortToken = getByKey(tokensData, market.shortTokenAddress);
                                        var indexToken = getByKey(tokensData, convertTokenAddress(_this.chainId, market.indexTokenAddress, 'native'));
                                        acc[marketAddress] = __assign(__assign({}, market), { isDisabled: dataStoreValues.isDisabled.returnValues[0], longToken: longToken, shortToken: shortToken, indexToken: indexToken, longInterestUsd: longInterestUsd, shortInterestUsd: shortInterestUsd, longInterestInTokens: longInterestInTokens, shortInterestInTokens: shortInterestInTokens, longPoolAmount: BigNumber.from(dataStoreValues.longPoolAmount.returnValues[0]), shortPoolAmount: BigNumber.from(dataStoreValues.shortPoolAmount.returnValues[0]), maxLongPoolAmount: BigNumber.from(dataStoreValues.maxLongPoolAmount.returnValues[0]), maxShortPoolAmount: BigNumber.from(dataStoreValues.maxShortPoolAmount.returnValues[0]), longPoolAmountAdjustment: BigNumber.from(dataStoreValues.longPoolAmountAdjustment.returnValues[0]), shortPoolAmountAdjustment: BigNumber.from(dataStoreValues.shortPoolAmountAdjustment.returnValues[0]), poolValueMin: BigNumber.from(poolValueInfoMin.poolValue), poolValueMax: BigNumber.from(poolValueInfoMax.poolValue), reserveFactorLong: BigNumber.from(dataStoreValues.reserveFactorLong.returnValues[0]), reserveFactorShort: BigNumber.from(dataStoreValues.reserveFactorShort.returnValues[0]), openInterestReserveFactorLong: BigNumber.from(dataStoreValues.openInterestReserveFactorLong.returnValues[0]), openInterestReserveFactorShort: BigNumber.from(dataStoreValues.openInterestReserveFactorShort.returnValues[0]), totalBorrowingFees: BigNumber.from(poolValueInfoMax.totalBorrowingFees), positionImpactPoolAmount: BigNumber.from(dataStoreValues.positionImpactPoolAmount.returnValues[0]), swapImpactPoolAmountLong: BigNumber.from(dataStoreValues.swapImpactPoolAmountLong.returnValues[0]), swapImpactPoolAmountShort: BigNumber.from(dataStoreValues.swapImpactPoolAmountShort.returnValues[0]), borrowingFactorLong: BigNumber.from(dataStoreValues.borrowingFactorLong.returnValues[0]), borrowingFactorShort: BigNumber.from(dataStoreValues.borrowingFactorShort.returnValues[0]), borrowingExponentFactorLong: BigNumber.from(dataStoreValues.borrowingExponentFactorLong.returnValues[0]), borrowingExponentFactorShort: BigNumber.from(dataStoreValues.borrowingExponentFactorShort.returnValues[0]), fundingFactor: BigNumber.from(dataStoreValues.fundingFactor.returnValues[0]), fundingExponentFactor: BigNumber.from(dataStoreValues.fundingExponentFactor.returnValues[0]), pnlLongMax: BigNumber.from(poolValueInfoMax.longPnl), pnlLongMin: BigNumber.from(poolValueInfoMin.longPnl), pnlShortMax: BigNumber.from(poolValueInfoMax.shortPnl), pnlShortMin: BigNumber.from(poolValueInfoMin.shortPnl), netPnlMax: BigNumber.from(poolValueInfoMax.netPnl), netPnlMin: BigNumber.from(poolValueInfoMin.netPnl), maxPnlFactorForTradersLong: BigNumber.from(dataStoreValues.maxPnlFactorForTradersLong.returnValues[0]), maxPnlFactorForTradersShort: BigNumber.from(dataStoreValues.maxPnlFactorForTradersShort.returnValues[0]), minCollateralFactor: BigNumber.from(dataStoreValues.minCollateralFactor.returnValues[0]), minCollateralFactorForOpenInterestLong: BigNumber.from(dataStoreValues.minCollateralFactorForOpenInterestLong.returnValues[0]), minCollateralFactorForOpenInterestShort: BigNumber.from(dataStoreValues.minCollateralFactorForOpenInterestShort.returnValues[0]), claimableFundingAmountLong: dataStoreValues.claimableFundingAmountLong
                                                ? BigNumber.from((_a = dataStoreValues.claimableFundingAmountLong) === null || _a === void 0 ? void 0 : _a.returnValues[0])
                                                : undefined, claimableFundingAmountShort: dataStoreValues.claimableFundingAmountShort
                                                ? BigNumber.from((_b = dataStoreValues.claimableFundingAmountShort) === null || _b === void 0 ? void 0 : _b.returnValues[0])
                                                : undefined, positionFeeFactorForPositiveImpact: BigNumber.from(dataStoreValues.positionFeeFactorForPositiveImpact.returnValues[0]), positionFeeFactorForNegativeImpact: BigNumber.from(dataStoreValues.positionFeeFactorForNegativeImpact.returnValues[0]), positionImpactFactorPositive: BigNumber.from(dataStoreValues.positionImpactFactorPositive.returnValues[0]), positionImpactFactorNegative: BigNumber.from(dataStoreValues.positionImpactFactorNegative.returnValues[0]), maxPositionImpactFactorPositive: BigNumber.from(dataStoreValues.maxPositionImpactFactorPositive.returnValues[0]), maxPositionImpactFactorNegative: BigNumber.from(dataStoreValues.maxPositionImpactFactorNegative.returnValues[0]), maxPositionImpactFactorForLiquidations: BigNumber.from(dataStoreValues.maxPositionImpactFactorForLiquidations.returnValues[0]), positionImpactExponentFactor: BigNumber.from(dataStoreValues.positionImpactExponentFactor.returnValues[0]), swapFeeFactorForPositiveImpact: BigNumber.from(dataStoreValues.swapFeeFactorForPositiveImpact.returnValues[0]), swapFeeFactorForNegativeImpact: BigNumber.from(dataStoreValues.swapFeeFactorForNegativeImpact.returnValues[0]), swapImpactFactorPositive: BigNumber.from(dataStoreValues.swapImpactFactorPositive.returnValues[0]), swapImpactFactorNegative: BigNumber.from(dataStoreValues.swapImpactFactorNegative.returnValues[0]), swapImpactExponentFactor: BigNumber.from(dataStoreValues.swapImpactExponentFactor.returnValues[0]), borrowingFactorPerSecondForLongs: BigNumber.from(readerValues.marketInfo.returnValues.borrowingFactorPerSecondForLongs), borrowingFactorPerSecondForShorts: BigNumber.from(readerValues.marketInfo.returnValues.borrowingFactorPerSecondForShorts), fundingFactorPerSecond: BigNumber.from(nextFunding.fundingFactorPerSecond), longsPayShorts: nextFunding.longsPayShorts, virtualPoolAmountForLongToken: BigNumber.from(virtualInventory.virtualPoolAmountForLongToken), virtualPoolAmountForShortToken: BigNumber.from(virtualInventory.virtualPoolAmountForShortToken), virtualInventoryForPositions: BigNumber.from(virtualInventory.virtualInventoryForPositions), virtualMarketId: dataStoreValues.virtualMarketId.returnValues[0], virtualLongTokenId: dataStoreValues.virtualLongTokenId.returnValues[0], virtualShortTokenId: dataStoreValues.virtualShortTokenId.returnValues[0] });
                                        return acc;
                                    }, {});
                                },
                            })];
                    case 3:
                        res = _b.sent();
                        return [2 /*return*/, { marketsInfoData: res.data, tokensData: tokensData, pricesUpdatedAt: pricesUpdatedAt }];
                }
            });
        }); };
        _this.getSwapRoutes = function (p) {
            var e_1, _a;
            var _b;
            if (!p.marketsInfoData)
                return;
            var fromTokenAddress = p.fromTokenAddress, toTokenAddress = p.toTokenAddress, marketsInfoData = p.marketsInfoData;
            var chainId = _this.chainId;
            var wrappedToken = getWrappedToken(chainId);
            var isWrap = fromTokenAddress === NATIVE_TOKEN_ADDRESS && toTokenAddress === wrappedToken.value;
            var isUnwrap = fromTokenAddress === wrappedToken.value && toTokenAddress === NATIVE_TOKEN_ADDRESS;
            var isSameToken = fromTokenAddress === toTokenAddress;
            var wrappedFromAddress = convertTokenAddress(chainId, fromTokenAddress, 'wrapped');
            var wrappedToAddress = convertTokenAddress(chainId, toTokenAddress, 'wrapped');
            var graph = getMarketsGraph(Object.values(marketsInfoData));
            var estimator = createSwapEstimator(marketsInfoData);
            var allRoutes = isWrap || isUnwrap || isSameToken
                ? undefined
                : (_b = findAllPaths(marketsInfoData, graph, wrappedFromAddress, wrappedToAddress)) === null || _b === void 0 ? void 0 : _b.sort(function (a, b) {
                    return b.liquidity.sub(a.liquidity).gt(0) ? 1 : -1;
                }).slice(0, 5);
            var maxLiquidity = BigNumber.from(0);
            var maxLiquidityPath = undefined;
            if (!allRoutes || !marketsInfoData || !wrappedFromAddress) {
                return { maxLiquidity: maxLiquidity, maxLiquidityPath: maxLiquidityPath };
            }
            try {
                for (var allRoutes_1 = __values(allRoutes), allRoutes_1_1 = allRoutes_1.next(); !allRoutes_1_1.done; allRoutes_1_1 = allRoutes_1.next()) {
                    var route = allRoutes_1_1.value;
                    var liquidity = getMaxSwapPathLiquidity({
                        marketsInfoData: marketsInfoData,
                        swapPath: route.path,
                        initialCollateralAddress: wrappedFromAddress,
                    });
                    if (liquidity.gt(maxLiquidity)) {
                        maxLiquidity = liquidity;
                        maxLiquidityPath = route.path;
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (allRoutes_1_1 && !allRoutes_1_1.done && (_a = allRoutes_1.return)) _a.call(allRoutes_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            var findSwapPath = function (usdIn, opts) {
                if (!(allRoutes === null || allRoutes === void 0 ? void 0 : allRoutes.length) || !estimator || !marketsInfoData || !fromTokenAddress) {
                    return undefined;
                }
                var swapPath = undefined;
                if (opts.byLiquidity) {
                    swapPath = allRoutes[0].path;
                }
                else {
                    swapPath = getBestSwapPath(allRoutes, usdIn, estimator);
                }
                if (!swapPath) {
                    return undefined;
                }
                var swapPathStats = getSwapPathStats({
                    marketsInfoData: marketsInfoData,
                    swapPath: swapPath,
                    initialCollateralAddress: fromTokenAddress,
                    wrappedNativeTokenAddress: wrappedToken.value,
                    shouldUnwrapNativeToken: toTokenAddress === NATIVE_TOKEN_ADDRESS,
                    shouldApplyPriceImpact: true,
                    usdIn: usdIn,
                });
                if (!swapPathStats) {
                    return undefined;
                }
                return swapPathStats;
            };
            return {
                maxSwapLiquidity: maxLiquidity,
                maxLiquiditySwapPath: maxLiquidityPath,
                findSwapPath: findSwapPath,
            };
        };
        _this.getTokenData = function (_a) {
            var address = _a.address;
            return __awaiter(_this, void 0, void 0, function () {
                var tokensData;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, this.getTokensData()];
                        case 1:
                            tokensData = (_b.sent()).tokensData;
                            if (!tokensData)
                                return [2 /*return*/];
                            return [2 /*return*/, tokensData[address]];
                    }
                });
            });
        };
        _this.getPositions = function (_a) {
            var marketsInfoData = _a.marketsInfoData, tokensData = _a.tokensData, pricesUpdatedAt = _a.pricesUpdatedAt;
            return __awaiter(_this, void 0, void 0, function () {
                var existingPositionsKeysSet, keysAndPrices, positionsData, optimisticPositionsData;
                var _this = this;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, runMulticall(this.chainId, 'usePositions-keys', this.library, {
                                key: this.account ? [this.account, pricesUpdatedAt] : null,
                                // Refresh on every prices update
                                refreshInterval: null,
                                clearUnusedKeys: true,
                                keepPreviousData: true,
                                request: function () { return ({
                                    dataStore: {
                                        contractAddress: getContract({ chainId: _this.chainId, name: 'DataStore' }) || '',
                                        abi: DataStoreAbi,
                                        calls: {
                                            keys: {
                                                methodName: 'getBytes32ValuesAt',
                                                params: [accountPositionListKey(_this.account), 0, 1000],
                                            },
                                        },
                                    },
                                }); },
                                parseResponse: function (res) {
                                    return new Set(res.data.dataStore.keys.returnValues);
                                },
                            })];
                        case 1:
                            existingPositionsKeysSet = (_b.sent()).data;
                            keysAndPrices = getKeysAndPricesParams({
                                marketsInfoData: marketsInfoData,
                                tokensData: tokensData,
                                account: this.account,
                                existingPositionsKeysSet: existingPositionsKeysSet,
                            });
                            return [4 /*yield*/, runMulticall(this.chainId, 'usePositionsData', this.library, {
                                    key: keysAndPrices.contractPositionsKeys.length
                                        ? [keysAndPrices.contractPositionsKeys.join('-'), pricesUpdatedAt]
                                        : null,
                                    // Refresh on every prices update
                                    refreshInterval: null,
                                    clearUnusedKeys: true,
                                    keepPreviousData: true,
                                    request: function () { return ({
                                        reader: {
                                            contractAddress: getContract({ chainId: _this.chainId, name: 'SyntheticsReader' }) || '',
                                            abi: SyntheticsReaderAbi,
                                            calls: {
                                                positions: {
                                                    methodName: 'getAccountPositionInfoList',
                                                    params: [
                                                        getContract({ chainId: _this.chainId, name: 'DataStore' }),
                                                        getContract({ chainId: _this.chainId, name: 'ReferralStorage' }),
                                                        keysAndPrices.contractPositionsKeys,
                                                        keysAndPrices.marketsPrices,
                                                        // uiFeeReceiver
                                                        ethers.constants.AddressZero,
                                                    ],
                                                },
                                            },
                                        },
                                    }); },
                                    parseResponse: function (res) {
                                        var positions = res.data.reader.positions.returnValues;
                                        return positions.reduce(function (positionsMap, positionInfo, i) {
                                            var position = positionInfo.position, fees = positionInfo.fees;
                                            var addresses = position.addresses, numbers = position.numbers, flags = position.flags, data = position.data;
                                            var account = addresses.account, marketAddress = addresses.market, collateralTokenAddress = addresses.collateralToken;
                                            // Empty position
                                            if (BigNumber.from(numbers.increasedAtBlock).eq(0)) {
                                                return positionsMap;
                                            }
                                            var positionKey = getPositionKey(account, marketAddress, collateralTokenAddress, flags.isLong);
                                            var contractPositionKey = keysAndPrices.contractPositionsKeys[i];
                                            positionsMap[positionKey] = {
                                                key: positionKey,
                                                contractKey: contractPositionKey,
                                                account: account,
                                                marketAddress: marketAddress,
                                                collateralTokenAddress: collateralTokenAddress,
                                                sizeInUsd: BigNumber.from(numbers.sizeInUsd),
                                                sizeInTokens: BigNumber.from(numbers.sizeInTokens),
                                                collateralAmount: BigNumber.from(numbers.collateralAmount),
                                                increasedAtBlock: BigNumber.from(numbers.increasedAtBlock),
                                                decreasedAtBlock: BigNumber.from(numbers.decreasedAtBlock),
                                                isLong: flags.isLong,
                                                pendingBorrowingFeesUsd: BigNumber.from(fees.borrowing.borrowingFeeUsd),
                                                fundingFeeAmount: BigNumber.from(fees.funding.fundingFeeAmount),
                                                claimableLongTokenAmount: BigNumber.from(fees.funding.claimableLongTokenAmount),
                                                claimableShortTokenAmount: BigNumber.from(fees.funding.claimableShortTokenAmount),
                                                data: data,
                                            };
                                            return positionsMap;
                                        }, {});
                                    },
                                })];
                        case 2:
                            positionsData = (_b.sent()).data;
                            optimisticPositionsData = getOptimisticPositions({
                                positionsData: positionsData,
                                allPositionsKeys: keysAndPrices === null || keysAndPrices === void 0 ? void 0 : keysAndPrices.allPositionsKeys,
                            });
                            return [2 /*return*/, {
                                    positionsData: optimisticPositionsData,
                                }];
                    }
                });
            });
        };
        _this.getIncreaseAmounts = function (_a) {
            var marketsInfoData = _a.marketsInfoData, fromTokenAddress = _a.fromTokenAddress, toTokenAddress = _a.toTokenAddress, fromTokenAmount = _a.fromTokenAmount, toTokenAmount = _a.toTokenAmount, collateralInToken = _a.collateralInToken, tradeType = _a.tradeType, tradeMode = _a.tradeMode, marketAddress = _a.marketAddress, tokensData = _a.tokensData;
            return __awaiter(_this, void 0, void 0, function () {
                var toToken, fromToken, market, tradeOptions, swapRoute, values;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!toTokenAddress || !fromTokenAddress) {
                                return [2 /*return*/, undefined];
                            }
                            return [4 /*yield*/, this.getTokenData({ address: toTokenAddress })];
                        case 1:
                            toToken = _b.sent();
                            return [4 /*yield*/, this.getTokenData({ address: fromTokenAddress })];
                        case 2:
                            fromToken = _b.sent();
                            if (!toToken || !fromToken) {
                                console.error("token not found");
                                return [2 /*return*/, undefined];
                            }
                            if (!marketsInfoData || !marketAddress)
                                return [2 /*return*/];
                            market = marketsInfoData[marketAddress];
                            tradeOptions = this.getSelectedTradeOption({
                                tradeType: tradeType,
                                tradeMode: tradeMode,
                                marketsInfoData: marketsInfoData,
                                market: market,
                                tokensData: tokensData,
                                fromTokenAddress: fromTokenAddress,
                                toTokenAddress: toTokenAddress,
                                collateralInToken: collateralInToken,
                            });
                            swapRoute = this.getSwapRoutes({
                                marketsInfoData: marketsInfoData,
                                fromTokenAddress: fromTokenAddress,
                                toTokenAddress: (tradeOptions === null || tradeOptions === void 0 ? void 0 : tradeOptions.collateralAddress) || toTokenAddress,
                            });
                            if (!swapRoute) {
                                console.error("swapRoute not found");
                                return [2 /*return*/, undefined];
                            }
                            if (!tradeOptions) {
                                console.error('trade error');
                                return [2 /*return*/];
                            }
                            if (!tradeOptions.marketInfo) {
                                console.error('marketInfo error');
                                return [2 /*return*/];
                            }
                            if (!tradeOptions.collateralToken) {
                                console.error('collateralToken error');
                                return [2 /*return*/];
                            }
                            if (!(swapRoute === null || swapRoute === void 0 ? void 0 : swapRoute.findSwapPath)) {
                                console.error('swapRoute error');
                                return [2 /*return*/];
                            }
                            values = getIncreasePositionAmounts({
                                marketInfo: tradeOptions === null || tradeOptions === void 0 ? void 0 : tradeOptions.marketInfo,
                                indexToken: toToken,
                                initialCollateralToken: fromToken,
                                collateralToken: tradeOptions.collateralToken,
                                isLong: tradeOptions.tradeType === TradeType.Long,
                                initialCollateralAmount: BigNumber.from(fromTokenAmount),
                                indexTokenAmount: BigNumber.from(toTokenAmount),
                                leverage: BigNumber.from('15000'),
                                triggerPrice: undefined,
                                position: undefined,
                                findSwapPath: swapRoute.findSwapPath,
                                strategy: 'leverageByCollateral',
                                userReferralInfo: undefined,
                                // strategy: isLeverageEnabled
                                //   ? focusedInput === 'from'
                                //     ? 'leverageByCollateral'
                                //     : 'leverageBySize'
                                //   : 'independent',
                            });
                            return [2 /*return*/, { marketInfo: tradeOptions === null || tradeOptions === void 0 ? void 0 : tradeOptions.marketInfo, values: values }];
                    }
                });
            });
        };
        _this.getCloseAmounts = function (_a) {
            var closingPositionKey = _a.closingPositionKey, marketsInfoData = _a.marketsInfoData, tokensData = _a.tokensData, pricesUpdatedAt = _a.pricesUpdatedAt;
            return __awaiter(_this, void 0, void 0, function () {
                var _b, minCollateralUsd, minPositionSizeUsd, savedAcceptablePriceImpactBps, values, positionsInfoData, position, collateralToken, marketInfo, indexToken, isLong, pnlToken, markPrice, isTrigger, maxCloseAmount, closeSizeUsd, estimatedCollateralUsd, estimatedCollateralDeltaUsd, profitUsd, profitAmount, positionFeeInfo, estimatedPositionFeeCost, estimatedDiscountCost, borrowFeeCost, fundingFeeCost, swapProfitStats, negativePnlUsd, negativePriceImpactUsd, priceImpactDiffUsd, totalFeesUsd, payedInfo;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0: return [4 /*yield*/, this.getPositionsConstants()];
                        case 1:
                            _b = _c.sent(), minCollateralUsd = _b.minCollateralUsd, minPositionSizeUsd = _b.minPositionSizeUsd;
                            savedAcceptablePriceImpactBps = undefined;
                            values = {
                                isFullClose: false,
                                sizeDeltaUsd: BigNumber.from(0),
                                sizeDeltaInTokens: BigNumber.from(0),
                                collateralDeltaUsd: BigNumber.from(0),
                                collateralDeltaAmount: BigNumber.from(0),
                                indexPrice: BigNumber.from(0),
                                collateralPrice: BigNumber.from(0),
                                triggerPrice: BigNumber.from(0),
                                acceptablePrice: BigNumber.from(0),
                                positionPriceImpactDeltaUsd: BigNumber.from(0),
                                priceImpactDiffUsd: BigNumber.from(0),
                                acceptablePriceDeltaBps: BigNumber.from(0),
                                estimatedPnl: BigNumber.from(0),
                                estimatedPnlPercentage: BigNumber.from(0),
                                realizedPnl: BigNumber.from(0),
                                positionFeeUsd: BigNumber.from(0),
                                borrowingFeeUsd: BigNumber.from(0),
                                fundingFeeUsd: BigNumber.from(0),
                                feeDiscountUsd: BigNumber.from(0),
                                swapProfitFeeUsd: BigNumber.from(0),
                                payedOutputUsd: BigNumber.from(0),
                                payedRemainingCollateralUsd: BigNumber.from(0),
                                payedRemainingCollateralAmount: BigNumber.from(0),
                                receiveTokenAmount: BigNumber.from(0),
                                receiveUsd: BigNumber.from(0),
                                triggerOrderType: undefined,
                                triggerThresholdType: undefined,
                                decreaseSwapType: DecreasePositionSwapType.NoSwap,
                            };
                            return [4 /*yield*/, this.getPositionsInfo({
                                    tokensData: tokensData,
                                    marketsInfoData: marketsInfoData,
                                    pricesUpdatedAt: pricesUpdatedAt,
                                })];
                        case 2:
                            positionsInfoData = (_c.sent()).positionsInfoData;
                            position = getByKey(positionsInfoData, closingPositionKey);
                            if (!position) {
                                console.error("position not found");
                                return [2 /*return*/];
                            }
                            collateralToken = position.collateralToken, marketInfo = position.marketInfo, indexToken = position.indexToken, isLong = position.isLong;
                            pnlToken = isLong ? marketInfo.longToken : marketInfo.shortToken;
                            values.decreaseSwapType = getIsEquivalentTokens(pnlToken, collateralToken)
                                ? DecreasePositionSwapType.NoSwap
                                : DecreasePositionSwapType.SwapPnlTokenToCollateralToken;
                            markPrice = getMarkPrice({ prices: indexToken.prices, isIncrease: false, isLong: isLong });
                            isTrigger = false;
                            values.indexPrice = markPrice;
                            values.collateralPrice = collateralToken.prices.minPrice;
                            maxCloseAmount = formatAmountFree(position === null || position === void 0 ? void 0 : position.sizeInUsd, USD_DECIMALS);
                            closeSizeUsd = parseValue(maxCloseAmount || '0', USD_DECIMALS);
                            estimatedCollateralUsd = convertToUsd(position.collateralAmount, collateralToken.decimals, values.collateralPrice);
                            values.sizeDeltaUsd = closeSizeUsd;
                            estimatedCollateralDeltaUsd = BigNumber.from(0);
                            values.isFullClose = getIsFullClose({
                                position: position,
                                sizeDeltaUsd: values.sizeDeltaUsd,
                                indexPrice: values.indexPrice,
                                remainingCollateralUsd: estimatedCollateralUsd.sub(estimatedCollateralDeltaUsd),
                                minCollateralUsd: minCollateralUsd || BigNumber.from('0'),
                                minPositionSizeUsd: minPositionSizeUsd || BigNumber.from('0'),
                            });
                            if (values.isFullClose) {
                                values.sizeDeltaUsd = position.sizeInUsd;
                                values.sizeDeltaInTokens = position.sizeInTokens;
                            }
                            else {
                                if (position.isLong) {
                                    values.sizeDeltaInTokens = roundUpDivision(position.sizeInTokens.mul(values.sizeDeltaUsd), position.sizeInUsd);
                                }
                                else {
                                    values.sizeDeltaInTokens = position.sizeInTokens.mul(values.sizeDeltaUsd).div(position.sizeInUsd);
                                }
                            }
                            // PNL
                            values.estimatedPnl = getPositionPnlUsd({
                                marketInfo: marketInfo,
                                sizeInUsd: position.sizeInUsd,
                                sizeInTokens: position.sizeInTokens,
                                markPrice: values.indexPrice,
                                isLong: isLong,
                            });
                            values.realizedPnl = values.estimatedPnl.mul(values.sizeDeltaInTokens).div(position.sizeInTokens);
                            values.estimatedPnlPercentage = !estimatedCollateralUsd.eq(0)
                                ? getBasisPoints(values.estimatedPnl, estimatedCollateralUsd)
                                : BigNumber.from(0);
                            applyAcceptablePrice({
                                marketInfo: marketInfo,
                                isLong: isLong,
                                isTrigger: isTrigger,
                                savedAcceptablePriceImpactBps: savedAcceptablePriceImpactBps,
                                values: values,
                            });
                            profitUsd = BigNumber.from(0);
                            if (values.realizedPnl.gt(0)) {
                                profitUsd = profitUsd.add(values.realizedPnl);
                            }
                            if (values.positionPriceImpactDeltaUsd.gt(0)) {
                                profitUsd = profitUsd.add(values.positionPriceImpactDeltaUsd);
                            }
                            profitAmount = convertToTokenAmount(profitUsd, collateralToken.decimals, values.collateralPrice);
                            positionFeeInfo = getPositionFee(marketInfo, values.sizeDeltaUsd, values.positionPriceImpactDeltaUsd.gt(0), undefined);
                            estimatedPositionFeeCost = estimateCollateralCost(positionFeeInfo.positionFeeUsd, collateralToken, values.collateralPrice);
                            estimatedDiscountCost = estimateCollateralCost(positionFeeInfo.discountUsd, collateralToken, values.collateralPrice);
                            values.positionFeeUsd = estimatedPositionFeeCost.usd;
                            values.feeDiscountUsd = estimatedDiscountCost.usd;
                            borrowFeeCost = estimateCollateralCost(position.pendingBorrowingFeesUsd, collateralToken, values.collateralPrice);
                            values.borrowingFeeUsd = borrowFeeCost.usd;
                            fundingFeeCost = estimateCollateralCost(position.pendingFundingFeesUsd, collateralToken, values.collateralPrice);
                            values.fundingFeeUsd = fundingFeeCost.usd;
                            if (profitUsd.gt(0) && values.decreaseSwapType === DecreasePositionSwapType.SwapPnlTokenToCollateralToken) {
                                swapProfitStats = getSwapStats({
                                    marketInfo: marketInfo,
                                    tokenInAddress: pnlToken.value,
                                    tokenOutAddress: collateralToken.value,
                                    usdIn: profitUsd,
                                    shouldApplyPriceImpact: true,
                                });
                                values.swapProfitFeeUsd = swapProfitStats.swapFeeUsd.add(swapProfitStats.priceImpactDeltaUsd.mul(-1));
                            }
                            else {
                                values.swapProfitFeeUsd = BigNumber.from(0);
                            }
                            negativePnlUsd = values.realizedPnl.lt(0) ? values.realizedPnl.abs() : BigNumber.from(0);
                            negativePriceImpactUsd = values.positionPriceImpactDeltaUsd.lt(0)
                                ? values.positionPriceImpactDeltaUsd.abs()
                                : BigNumber.from(0);
                            priceImpactDiffUsd = values.priceImpactDiffUsd.gt(0) ? values.priceImpactDiffUsd : BigNumber.from(0);
                            totalFeesUsd = values.positionFeeUsd
                                .add(values.borrowingFeeUsd)
                                .add(values.fundingFeeUsd)
                                .add(values.swapProfitFeeUsd)
                                .add(negativePnlUsd)
                                .add(negativePriceImpactUsd)
                                .add(priceImpactDiffUsd);
                            payedInfo = payForCollateralCost({
                                initialCostUsd: totalFeesUsd,
                                collateralToken: collateralToken,
                                collateralPrice: values.collateralPrice,
                                outputAmount: profitAmount,
                                remainingCollateralAmount: position.collateralAmount,
                            });
                            values.payedOutputUsd = convertToUsd(payedInfo.paidOutputAmount, collateralToken.decimals, values.collateralPrice);
                            values.payedRemainingCollateralAmount = payedInfo.paidRemainingCollateralAmount;
                            values.payedRemainingCollateralUsd = convertToUsd(payedInfo.paidRemainingCollateralAmount, collateralToken.decimals, values.collateralPrice);
                            values.receiveTokenAmount = payedInfo.outputAmount;
                            // Collateral delta
                            if (values.isFullClose) {
                                values.collateralDeltaUsd = estimatedCollateralUsd;
                                values.collateralDeltaAmount = position.collateralAmount;
                                values.receiveTokenAmount = payedInfo.outputAmount.add(payedInfo.remainingCollateralAmount);
                            }
                            else {
                                values.collateralDeltaUsd = BigNumber.from(0);
                                values.collateralDeltaAmount = BigNumber.from(0);
                                values.receiveTokenAmount = payedInfo.outputAmount;
                            }
                            values.receiveUsd = convertToUsd(values.receiveTokenAmount, collateralToken.decimals, values.collateralPrice);
                            return [2 /*return*/, { marketInfo: marketInfo, values: values, position: position }];
                    }
                });
            });
        };
        _this.getSelectedPosition = function (_a) {
            var marketAddress = _a.marketAddress, collateralAddress = _a.collateralAddress, isLong = _a.isLong, positionsInfoData = _a.positionsInfoData;
            var positionKey = getPositionKey(_this.account, marketAddress, collateralAddress, isLong);
            var selectedPosition = getByKey(positionsInfoData, positionKey);
            return selectedPosition;
        };
        _this.getIncreasePositionParams = function (_a) {
            var fromTokenAddress = _a.fromTokenAddress, toTokenAddress = _a.toTokenAddress, fromTokenAmount = _a.fromTokenAmount, toTokenAmount = _a.toTokenAmount, collateralInToken = _a.collateralInToken, tradeType = _a.tradeType, tradeMode = _a.tradeMode, marketAddress = _a.marketAddress, referralCode = _a.referralCode;
            return __awaiter(_this, void 0, void 0, function () {
                var marketsInfoData, _b, tokens, _c, tokensData, pricesUpdatedAt, increasePositionAmounts, values, marketInfo, isNativePayment, initialCollateralTokenAddress, tradeFlags, fees, wntCollateralAmount, totalWntAmount, shouldApplySlippage, acceptablePrice, orderVaultAddress, multicall, exchangeRouter, encodedPayload;
                var _d, _e, _f, _g;
                return __generator(this, function (_h) {
                    switch (_h.label) {
                        case 0:
                            _b = this.marketsInfo;
                            if (_b) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.getMarketsInfo()];
                        case 1:
                            _b = ((_d = (_h.sent())) === null || _d === void 0 ? void 0 : _d.marketsInfoData);
                            _h.label = 2;
                        case 2:
                            marketsInfoData = _b;
                            _c = this.tokensData;
                            if (_c) return [3 /*break*/, 4];
                            return [4 /*yield*/, this.getTokensData()];
                        case 3:
                            _c = (_h.sent());
                            _h.label = 4;
                        case 4:
                            tokens = _c;
                            if (!tokens) {
                                return [2 /*return*/];
                            }
                            tokensData = tokens.tokensData, pricesUpdatedAt = tokens.pricesUpdatedAt;
                            return [4 /*yield*/, this.getIncreaseAmounts({
                                    marketsInfoData: marketsInfoData,
                                    fromTokenAddress: fromTokenAddress,
                                    toTokenAddress: toTokenAddress,
                                    collateralInToken: collateralInToken,
                                    fromTokenAmount: fromTokenAmount,
                                    toTokenAmount: toTokenAmount,
                                    tradeType: tradeType,
                                    tradeMode: tradeMode,
                                    marketAddress: marketAddress,
                                    tokensData: tokensData,
                                })];
                        case 5:
                            increasePositionAmounts = _h.sent();
                            if (!increasePositionAmounts) {
                                console.error('get increasePositionAmounts error');
                                return [2 /*return*/];
                            }
                            values = increasePositionAmounts.values, marketInfo = increasePositionAmounts.marketInfo;
                            isNativePayment = fromTokenAddress === NATIVE_TOKEN_ADDRESS;
                            initialCollateralTokenAddress = convertTokenAddress(this.chainId, fromTokenAddress, 'wrapped');
                            tradeFlags = getTradeFlags(tradeType, tradeMode);
                            return [4 /*yield*/, this.getIncreaseAmountsFees({
                                    increaseAmounts: values,
                                    marketsInfoData: marketsInfoData,
                                    tokensData: tokensData,
                                    pricesUpdatedAt: pricesUpdatedAt,
                                })];
                        case 6:
                            fees = _h.sent();
                            wntCollateralAmount = isNativePayment ? values.initialCollateralAmount : BigNumber.from(0);
                            totalWntAmount = wntCollateralAmount.add(((_e = fees === null || fees === void 0 ? void 0 : fees.executionFee) === null || _e === void 0 ? void 0 : _e.feeTokenAmount.toString()) || '0');
                            shouldApplySlippage = isMarketOrderType(OrderType.MarketIncrease);
                            acceptablePrice = shouldApplySlippage
                                ? applySlippageToPrice(ALLOWED_SLIPPAGE, values.acceptablePrice, true, tradeFlags.isLong)
                                : values.acceptablePrice;
                            orderVaultAddress = getContract({ chainId: this.chainId, name: 'OrderVault' });
                            multicall = [
                                { method: 'sendWnt', params: [orderVaultAddress, totalWntAmount] },
                                !isNativePayment
                                    ? {
                                        method: 'sendTokens',
                                        params: [initialCollateralTokenAddress, orderVaultAddress, values.initialCollateralAmount],
                                    }
                                    : undefined,
                                {
                                    method: 'createOrder',
                                    params: [
                                        {
                                            addresses: {
                                                receiver: this.account,
                                                initialCollateralToken: initialCollateralTokenAddress,
                                                callbackContract: AddressZero,
                                                market: marketAddress,
                                                swapPath: (_f = values.swapPathStats) === null || _f === void 0 ? void 0 : _f.swapPath,
                                                uiFeeReceiver: AddressZero,
                                            },
                                            numbers: {
                                                sizeDeltaUsd: values.sizeDeltaUsd,
                                                initialCollateralDeltaAmount: BigNumber.from(0),
                                                triggerPrice: convertToContractPrice(values.triggerPrice || BigNumber.from(0), marketInfo.indexToken.decimals).toString(),
                                                acceptablePrice: convertToContractPrice(acceptablePrice, marketInfo.indexToken.decimals),
                                                executionFee: ((_g = fees === null || fees === void 0 ? void 0 : fees.executionFee) === null || _g === void 0 ? void 0 : _g.feeTokenAmount) || '0',
                                                callbackGasLimit: BigNumber.from(0),
                                                minOutputAmount: BigNumber.from(0),
                                            },
                                            orderType: tradeFlags.isLimit ? OrderType.LimitIncrease : OrderType.MarketIncrease,
                                            decreasePositionSwapType: DecreasePositionSwapType.NoSwap,
                                            isLong: tradeFlags.isLong,
                                            shouldUnwrapNativeToken: isNativePayment,
                                            referralCode: referralCode || ethers.constants.HashZero,
                                        },
                                    ],
                                },
                            ];
                            exchangeRouter = new ethers.Contract(getContract({ chainId: this.chainId, name: 'ExchangeRouter' }) || '', exchangeRouterAbi, this.library.getSigner());
                            encodedPayload = multicall.filter(Boolean).map(function (call) {
                                return exchangeRouter.interface.encodeFunctionData(call.method, call.params);
                            });
                            return [2 /*return*/, { encodedPayload: encodedPayload, totalWntAmount: totalWntAmount }];
                    }
                });
            });
        };
        _this.getClosePositionParams = function (_a) {
            var closingPositionKey = _a.closingPositionKey, receiveTokenAddress = _a.receiveTokenAddress;
            return __awaiter(_this, void 0, void 0, function () {
                var marketsInfoData, _b, tokens, _c, tokensData, pricesUpdatedAt, closePositionAmounts, values, position, isNativeReceive, swapRoutes, findSwapPath, receiveToken, swapAmounts, shouldSwap, fees, dec, totalWntAmount, shouldApplySlippage, orderVaultAddress, initialCollateralTokenAddress, acceptablePrice, minOutputUsd, minOutputAmount, multicall, exchangeRouter, encodedPayload;
                var _d, _e, _f, _g;
                return __generator(this, function (_h) {
                    switch (_h.label) {
                        case 0:
                            _b = this.marketsInfo;
                            if (_b) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.getMarketsInfo()];
                        case 1:
                            _b = ((_d = (_h.sent())) === null || _d === void 0 ? void 0 : _d.marketsInfoData);
                            _h.label = 2;
                        case 2:
                            marketsInfoData = _b;
                            _c = this.tokensData;
                            if (_c) return [3 /*break*/, 4];
                            return [4 /*yield*/, this.getTokensData()];
                        case 3:
                            _c = (_h.sent());
                            _h.label = 4;
                        case 4:
                            tokens = _c;
                            if (!tokens) {
                                return [2 /*return*/];
                            }
                            tokensData = tokens.tokensData, pricesUpdatedAt = tokens.pricesUpdatedAt;
                            return [4 /*yield*/, this.getCloseAmounts({
                                    closingPositionKey: closingPositionKey,
                                    marketsInfoData: marketsInfoData,
                                    tokensData: tokensData,
                                    pricesUpdatedAt: pricesUpdatedAt,
                                })];
                        case 5:
                            closePositionAmounts = _h.sent();
                            if (!closePositionAmounts) {
                                console.error('get closePositionAmounts error');
                                return [2 /*return*/];
                            }
                            values = closePositionAmounts.values, position = closePositionAmounts.position;
                            isNativeReceive = receiveTokenAddress === NATIVE_TOKEN_ADDRESS;
                            swapRoutes = this.getSwapRoutes({
                                marketsInfoData: marketsInfoData,
                                fromTokenAddress: position === null || position === void 0 ? void 0 : position.collateralTokenAddress,
                                toTokenAddress: receiveTokenAddress,
                            });
                            if (!swapRoutes)
                                return [2 /*return*/];
                            findSwapPath = swapRoutes.findSwapPath;
                            return [4 /*yield*/, this.getTokenData({ address: receiveTokenAddress })];
                        case 6:
                            receiveToken = _h.sent();
                            if (!receiveToken) {
                                console.error("Get receive token error");
                                return [2 /*return*/];
                            }
                            shouldSwap = position && receiveToken && !getIsEquivalentTokens(position.collateralToken, receiveToken);
                            if (!shouldSwap || !receiveToken || !(values === null || values === void 0 ? void 0 : values.receiveTokenAmount) || !position) {
                                swapAmounts = undefined;
                            }
                            else {
                                swapAmounts = getSwapAmountsByFromValue({
                                    tokenIn: position.collateralToken,
                                    tokenOut: receiveToken,
                                    amountIn: values.receiveTokenAmount,
                                    isLimit: false,
                                    findSwapPath: findSwapPath,
                                });
                            }
                            return [4 /*yield*/, this.getDecreaseAmountsFees({
                                    decreaseAmounts: values,
                                    swapAmounts: swapAmounts,
                                    marketsInfoData: marketsInfoData,
                                    tokensData: tokensData,
                                    pricesUpdatedAt: pricesUpdatedAt,
                                    receiveTokenAddress: receiveTokenAddress,
                                    position: position,
                                })];
                        case 7:
                            fees = _h.sent();
                            dec = values.receiveTokenAmount;
                            totalWntAmount = ((_e = fees === null || fees === void 0 ? void 0 : fees.executionFee) === null || _e === void 0 ? void 0 : _e.feeTokenAmount.toString()) || '0';
                            shouldApplySlippage = isMarketOrderType(OrderType.MarketIncrease);
                            orderVaultAddress = getContract({ chainId: this.chainId, name: 'OrderVault' });
                            initialCollateralTokenAddress = convertTokenAddress(this.chainId, position.collateralTokenAddress, 'wrapped');
                            acceptablePrice = shouldApplySlippage
                                ? applySlippageToPrice(ALLOWED_SLIPPAGE, values.acceptablePrice, false, position.isLong)
                                : values.acceptablePrice;
                            minOutputUsd = BigNumber.from(0);
                            minOutputAmount = shouldApplySlippage ? applySlippageToMinOut(ALLOWED_SLIPPAGE, minOutputUsd) : minOutputUsd;
                            multicall = [
                                { method: 'sendWnt', params: [orderVaultAddress, totalWntAmount.toString()] },
                                {
                                    method: 'createOrder',
                                    params: [
                                        {
                                            addresses: {
                                                receiver: this.account,
                                                initialCollateralToken: initialCollateralTokenAddress,
                                                callbackContract: AddressZero,
                                                market: position.marketAddress,
                                                swapPath: ((_f = swapAmounts === null || swapAmounts === void 0 ? void 0 : swapAmounts.swapPathStats) === null || _f === void 0 ? void 0 : _f.swapPath) || [],
                                                uiFeeReceiver: ethers.constants.AddressZero,
                                            },
                                            numbers: {
                                                sizeDeltaUsd: values.sizeDeltaUsd.toString(),
                                                initialCollateralDeltaAmount: (values.collateralDeltaAmount || BigNumber.from(0)).toString(),
                                                triggerPrice: convertToContractPrice(values.triggerPrice || BigNumber.from(0), position.indexToken.decimals).toString(),
                                                acceptablePrice: convertToContractPrice(acceptablePrice, position.indexToken.decimals).toString(),
                                                executionFee: (_g = fees === null || fees === void 0 ? void 0 : fees.executionFee) === null || _g === void 0 ? void 0 : _g.feeTokenAmount.toString(),
                                                callbackGasLimit: BigNumber.from(0).toString(),
                                                minOutputAmount: minOutputAmount.toString(),
                                            },
                                            orderType: OrderType.MarketDecrease,
                                            decreasePositionSwapType: values.decreaseSwapType,
                                            isLong: position.isLong,
                                            shouldUnwrapNativeToken: isNativeReceive,
                                            referralCode: ethers.constants.HashZero,
                                        },
                                    ],
                                },
                            ];
                            exchangeRouter = new ethers.Contract(getContract({ chainId: this.chainId, name: 'ExchangeRouter' }) || '', exchangeRouterAbi, this.library.getSigner());
                            encodedPayload = multicall.filter(Boolean).map(function (call) {
                                return exchangeRouter.interface.encodeFunctionData(call.method, call.params);
                            });
                            return [2 /*return*/, { encodedPayload: encodedPayload, totalWntAmount: totalWntAmount }];
                    }
                });
            });
        };
        _this.getSelectedTradeOption = function (_a) {
            var marketsInfoData = _a.marketsInfoData, tradeType = _a.tradeType, tradeMode = _a.tradeMode, tokensData = _a.tokensData, fromTokenAddress = _a.fromTokenAddress, toTokenAddress = _a.toTokenAddress, collateralInToken = _a.collateralInToken, market = _a.market;
            if (!marketsInfoData) {
                console.error('missing market info');
                return;
            }
            if (!market) {
                console.error('missing market info');
                return;
            }
            var availableTokensOptions = getAvailabeTokenData({ chainId: _this.chainId, marketsInfoData: marketsInfoData, tokensData: tokensData });
            var avaialbleTradeModes = function () {
                var _a;
                if (!tradeType) {
                    return [];
                }
                return (_a = {},
                    _a[TradeType.Long] = [TradeMode.Market, TradeMode.Limit, TradeMode.Trigger],
                    _a[TradeType.Short] = [TradeMode.Market, TradeMode.Limit, TradeMode.Trigger],
                    _a[TradeType.Swap] = [TradeMode.Market, TradeMode.Limit],
                    _a)[tradeType];
            };
            var tradeFlags = getTradeFlags(tradeType, tradeMode);
            var isSwap = tradeFlags.isSwap, isLong = tradeFlags.isLong, isPosition = tradeFlags.isPosition;
            var fromToken = getByKey(tokensData, fromTokenAddress);
            var toToken = getByKey(tokensData, toTokenAddress);
            var isWrapOrUnwrap = Boolean(isSwap && fromToken && toToken && (getIsWrap(fromToken, toToken) || getIsUnwrap(fromToken, toToken)));
            var marketAddress = market.marketTokenAddress;
            var collateralAddress = collateralInToken || toTokenAddress
                ? market[tradeFlags.isLong ? 'longTokenAddress' : 'shortTokenAddress']
                : undefined;
            var marketInfo = marketsInfoData[marketAddress];
            var collateralToken = getByKey(tokensData, collateralAddress);
            return {
                tradeType: tradeType,
                tradeMode: tradeMode,
                tradeFlags: tradeFlags,
                isWrapOrUnwrap: isWrapOrUnwrap,
                fromTokenAddress: fromTokenAddress,
                fromToken: fromToken,
                toTokenAddress: toTokenAddress,
                toToken: toToken,
                marketAddress: marketAddress,
                marketInfo: marketInfo,
                collateralAddress: collateralAddress,
                collateralToken: collateralToken,
                availableTokensOptions: availableTokensOptions,
                avaialbleTradeModes: avaialbleTradeModes(),
            };
        };
        _this.getIncreaseAmountsFees = function (_a) {
            var increaseAmounts = _a.increaseAmounts, tokensData = _a.tokensData, marketsInfoData = _a.marketsInfoData, pricesUpdatedAt = _a.pricesUpdatedAt;
            return __awaiter(_this, void 0, void 0, function () {
                var gasLimits, estimatedGas, gasPrice, positionsInfoData;
                var _b, _c, _d, _e, _f;
                return __generator(this, function (_g) {
                    switch (_g.label) {
                        case 0:
                            if (!tokensData)
                                return [2 /*return*/];
                            return [4 /*yield*/, this.getGasLimits()];
                        case 1:
                            gasLimits = (_g.sent()).gasLimits;
                            if (!gasLimits)
                                return [2 /*return*/];
                            estimatedGas = estimateExecuteIncreaseOrderGasLimit(gasLimits, {
                                swapPath: ((_b = increaseAmounts.swapPathStats) === null || _b === void 0 ? void 0 : _b.swapPath) || [],
                            });
                            return [4 /*yield*/, this.getGasPrice()];
                        case 2:
                            gasPrice = _g.sent();
                            if (!gasPrice) {
                                return [2 /*return*/];
                            }
                            return [4 /*yield*/, this.getPositionsInfo({
                                    tokensData: tokensData,
                                    marketsInfoData: marketsInfoData,
                                    pricesUpdatedAt: pricesUpdatedAt,
                                })];
                        case 3:
                            positionsInfoData = (_g.sent()).positionsInfoData;
                            return [2 /*return*/, {
                                    fees: getTradeFees({
                                        isIncrease: true,
                                        initialCollateralUsd: increaseAmounts.initialCollateralUsd,
                                        sizeDeltaUsd: increaseAmounts.sizeDeltaUsd,
                                        swapSteps: ((_c = increaseAmounts.swapPathStats) === null || _c === void 0 ? void 0 : _c.swapSteps) || [],
                                        positionFeeUsd: increaseAmounts.positionFeeUsd,
                                        swapPriceImpactDeltaUsd: ((_d = increaseAmounts.swapPathStats) === null || _d === void 0 ? void 0 : _d.totalSwapPriceImpactDeltaUsd) || BigNumber.from(0),
                                        positionPriceImpactDeltaUsd: increaseAmounts.positionPriceImpactDeltaUsd,
                                        borrowingFeeUsd: ((_e = positionsInfoData === null || positionsInfoData === void 0 ? void 0 : positionsInfoData.pendingBorrowingFeesUsd) === null || _e === void 0 ? void 0 : _e.sizeInUsd) || BigNumber.from(0),
                                        fundingFeeUsd: ((_f = positionsInfoData === null || positionsInfoData === void 0 ? void 0 : positionsInfoData.pendingFundingFeesUsd) === null || _f === void 0 ? void 0 : _f.sizeInUsd) || BigNumber.from(0),
                                        feeDiscountUsd: increaseAmounts.feeDiscountUsd,
                                        swapProfitFeeUsd: BigNumber.from(0),
                                    }),
                                    executionFee: getExecutionFee(this.chainId, gasLimits, tokensData, estimatedGas, gasPrice),
                                    feesType: 'increase',
                                }];
                    }
                });
            });
        };
        _this.getDecreaseAmountsFees = function (_a) {
            var decreaseAmounts = _a.decreaseAmounts, position = _a.position, receiveTokenAddress = _a.receiveTokenAddress, swapAmounts = _a.swapAmounts, tokensData = _a.tokensData, marketsInfoData = _a.marketsInfoData, pricesUpdatedAt = _a.pricesUpdatedAt;
            return __awaiter(_this, void 0, void 0, function () {
                var gasLimits, gasPrice, estimatedGas;
                var _b, _c, _d;
                return __generator(this, function (_e) {
                    switch (_e.label) {
                        case 0:
                            if (!tokensData)
                                return [2 /*return*/];
                            return [4 /*yield*/, this.getGasLimits()];
                        case 1:
                            gasLimits = (_e.sent()).gasLimits;
                            return [4 /*yield*/, this.getGasPrice()];
                        case 2:
                            gasPrice = _e.sent();
                            if (!gasPrice) {
                                return [2 /*return*/];
                            }
                            if (!gasLimits)
                                return [2 /*return*/];
                            estimatedGas = estimateExecuteDecreaseOrderGasLimit(gasLimits, {
                                swapPath: ((_b = swapAmounts === null || swapAmounts === void 0 ? void 0 : swapAmounts.swapPathStats) === null || _b === void 0 ? void 0 : _b.swapPath) || [],
                            });
                            return [2 /*return*/, {
                                    fees: getTradeFees({
                                        isIncrease: false,
                                        initialCollateralUsd: position.collateralUsd,
                                        sizeDeltaUsd: decreaseAmounts.sizeDeltaUsd,
                                        swapSteps: ((_c = swapAmounts === null || swapAmounts === void 0 ? void 0 : swapAmounts.swapPathStats) === null || _c === void 0 ? void 0 : _c.swapSteps) || [],
                                        positionFeeUsd: decreaseAmounts.positionFeeUsd,
                                        swapPriceImpactDeltaUsd: ((_d = swapAmounts === null || swapAmounts === void 0 ? void 0 : swapAmounts.swapPathStats) === null || _d === void 0 ? void 0 : _d.totalSwapPriceImpactDeltaUsd) || BigNumber.from(0),
                                        positionPriceImpactDeltaUsd: decreaseAmounts.positionPriceImpactDeltaUsd,
                                        borrowingFeeUsd: decreaseAmounts.borrowingFeeUsd,
                                        fundingFeeUsd: decreaseAmounts.fundingFeeUsd,
                                        feeDiscountUsd: decreaseAmounts.feeDiscountUsd,
                                        swapProfitFeeUsd: decreaseAmounts.swapProfitFeeUsd,
                                    }),
                                    executionFee: getExecutionFee(this.chainId, gasLimits, tokensData, estimatedGas, gasPrice),
                                }];
                    }
                });
            });
        };
        _this.getPositionsInfo = function (_a) {
            var marketsInfoData = _a.marketsInfoData, tokensData = _a.tokensData, pricesUpdatedAt = _a.pricesUpdatedAt;
            return __awaiter(_this, void 0, void 0, function () {
                var positionsData, minCollateralUsd, positionsInfoData;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, this.getPositions({
                                marketsInfoData: marketsInfoData,
                                tokensData: tokensData,
                                pricesUpdatedAt: pricesUpdatedAt,
                            })];
                        case 1:
                            positionsData = (_b.sent()).positionsData;
                            return [4 /*yield*/, this.getPositionsConstants()];
                        case 2:
                            minCollateralUsd = (_b.sent()).minCollateralUsd;
                            if (!marketsInfoData || !tokensData || !positionsData || !minCollateralUsd) {
                                return [2 /*return*/, {
                                        isLoading: true,
                                    }];
                            }
                            positionsInfoData = Object.keys(positionsData).reduce(function (acc, positionKey) {
                                var position = getByKey(positionsData, positionKey);
                                var marketInfo = getByKey(marketsInfoData, position === null || position === void 0 ? void 0 : position.marketAddress);
                                var indexToken = marketInfo === null || marketInfo === void 0 ? void 0 : marketInfo.indexToken;
                                var pnlToken = position.isLong ? marketInfo === null || marketInfo === void 0 ? void 0 : marketInfo.longToken : marketInfo === null || marketInfo === void 0 ? void 0 : marketInfo.shortToken;
                                var collateralToken = getByKey(tokensData, position.collateralTokenAddress);
                                if (!marketInfo || !indexToken || !pnlToken || !collateralToken) {
                                    return acc;
                                }
                                var markPrice = getMarkPrice({ prices: indexToken.prices, isLong: position.isLong, isIncrease: false });
                                var collateralMinPrice = collateralToken.prices.minPrice;
                                var entryPrice = getEntryPrice({
                                    sizeInTokens: position.sizeInTokens,
                                    sizeInUsd: position.sizeInUsd,
                                    indexToken: indexToken,
                                });
                                var pendingFundingFeesUsd = convertToUsd(position.fundingFeeAmount, collateralToken.decimals, collateralToken.prices.minPrice);
                                var pendingClaimableFundingFeesLongUsd = convertToUsd(position.claimableLongTokenAmount, marketInfo.longToken.decimals, marketInfo.longToken.prices.minPrice);
                                var pendingClaimableFundingFeesShortUsd = convertToUsd(position.claimableShortTokenAmount, marketInfo.shortToken.decimals, marketInfo.shortToken.prices.minPrice);
                                var pendingClaimableFundingFeesUsd = pendingClaimableFundingFeesLongUsd === null || pendingClaimableFundingFeesLongUsd === void 0 ? void 0 : pendingClaimableFundingFeesLongUsd.add(pendingClaimableFundingFeesShortUsd);
                                var totalPendingFeesUsd = getPositionPendingFeesUsd({
                                    pendingBorrowingFeesUsd: position.pendingBorrowingFeesUsd,
                                    pendingFundingFeesUsd: pendingFundingFeesUsd,
                                });
                                var closingPriceImpactDeltaUsd = getPriceImpactForPosition(marketInfo, position.sizeInUsd.mul(-1), position.isLong, { fallbackToZero: true });
                                var positionFeeInfo = getPositionFee(marketInfo, position.sizeInUsd, closingPriceImpactDeltaUsd.gt(0), undefined);
                                var closingFeeUsd = positionFeeInfo.positionFeeUsd;
                                var collateralUsd = convertToUsd(position.collateralAmount, collateralToken.decimals, collateralMinPrice);
                                var remainingCollateralUsd = collateralUsd.sub(totalPendingFeesUsd);
                                var remainingCollateralAmount = convertToTokenAmount(remainingCollateralUsd, collateralToken.decimals, collateralMinPrice);
                                var pnl = getPositionPnlUsd({
                                    marketInfo: marketInfo,
                                    sizeInUsd: position.sizeInUsd,
                                    sizeInTokens: position.sizeInTokens,
                                    markPrice: markPrice,
                                    isLong: position.isLong,
                                });
                                var pnlPercentage = collateralUsd && !collateralUsd.eq(0) ? getBasisPoints(pnl, collateralUsd) : BigNumber.from(0);
                                var netValue = getPositionNetValue({
                                    collateralUsd: collateralUsd,
                                    pnl: pnl,
                                    pendingBorrowingFeesUsd: position.pendingBorrowingFeesUsd,
                                    pendingFundingFeesUsd: pendingFundingFeesUsd,
                                    closingFeeUsd: closingFeeUsd,
                                });
                                var pnlAfterFees = pnl.sub(totalPendingFeesUsd).sub(closingFeeUsd);
                                var pnlAfterFeesPercentage = !collateralUsd.eq(0)
                                    ? getBasisPoints(pnlAfterFees, collateralUsd.add(closingFeeUsd))
                                    : BigNumber.from(0);
                                var leverage = getLeverage({
                                    sizeInUsd: position.sizeInUsd,
                                    collateralUsd: collateralUsd,
                                    pnl: undefined,
                                    pendingBorrowingFeesUsd: position.pendingBorrowingFeesUsd,
                                    pendingFundingFeesUsd: pendingFundingFeesUsd,
                                });
                                var hasLowCollateral = (leverage === null || leverage === void 0 ? void 0 : leverage.gt(MAX_ALLOWED_LEVERAGE)) || false;
                                var liquidationPrice = getLiquidationPrice({
                                    marketInfo: marketInfo,
                                    collateralToken: collateralToken,
                                    sizeInUsd: position.sizeInUsd,
                                    sizeInTokens: position.sizeInTokens,
                                    collateralUsd: collateralUsd,
                                    collateralAmount: position.collateralAmount,
                                    userReferralInfo: undefined,
                                    minCollateralUsd: minCollateralUsd,
                                    pendingBorrowingFeesUsd: position.pendingBorrowingFeesUsd,
                                    pendingFundingFeesUsd: pendingFundingFeesUsd,
                                    isLong: position.isLong,
                                });
                                acc[positionKey] = __assign(__assign({}, position), { marketInfo: marketInfo, indexToken: indexToken, collateralToken: collateralToken, pnlToken: pnlToken, markPrice: markPrice, entryPrice: entryPrice, liquidationPrice: liquidationPrice, collateralUsd: collateralUsd, remainingCollateralUsd: remainingCollateralUsd, remainingCollateralAmount: remainingCollateralAmount, hasLowCollateral: hasLowCollateral, leverage: leverage, pnl: pnl, pnlPercentage: pnlPercentage, pnlAfterFees: pnlAfterFees, pnlAfterFeesPercentage: pnlAfterFeesPercentage, netValue: netValue, closingFeeUsd: closingFeeUsd, pendingFundingFeesUsd: pendingFundingFeesUsd, pendingClaimableFundingFeesUsd: pendingClaimableFundingFeesUsd });
                                return acc;
                            }, {});
                            return [2 /*return*/, {
                                    positionsInfoData: positionsInfoData,
                                    isLoading: false,
                                }];
                    }
                });
            });
        };
        _this.getGasLimits = function () { return __awaiter(_this, void 0, void 0, function () {
            var data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, runMulticall(this.chainId, 'useGasLimitsConfig', this.library, {
                            key: [],
                            refreshInterval: 60000,
                            request: function () { return ({
                                dataStore: {
                                    contractAddress: getContract({ chainId: _this.chainId, name: 'DataStore' }) || '',
                                    abi: DataStoreAbi,
                                    calls: {
                                        depositSingleToken: {
                                            methodName: 'getUint',
                                            params: [depositGasLimitKey(true)],
                                        },
                                        depositMultiToken: {
                                            methodName: 'getUint',
                                            params: [depositGasLimitKey(false)],
                                        },
                                        withdrawalMultiToken: {
                                            methodName: 'getUint',
                                            params: [withdrawalGasLimitKey()],
                                        },
                                        singleSwap: {
                                            methodName: 'getUint',
                                            params: [singleSwapGasLimitKey()],
                                        },
                                        swapOrder: {
                                            methodName: 'getUint',
                                            params: [swapOrderGasLimitKey()],
                                        },
                                        increaseOrder: {
                                            methodName: 'getUint',
                                            params: [increaseOrderGasLimitKey()],
                                        },
                                        decreaseOrder: {
                                            methodName: 'getUint',
                                            params: [decreaseOrderGasLimitKey()],
                                        },
                                        estimatedFeeBaseGasLimit: {
                                            methodName: 'getUint',
                                            params: [ESTIMATED_GAS_FEE_BASE_AMOUNT],
                                        },
                                        estimatedFeeMultiplierFactor: {
                                            methodName: 'getUint',
                                            params: [ESTIMATED_GAS_FEE_MULTIPLIER_FACTOR],
                                        },
                                    },
                                },
                            }); },
                            parseResponse: function (res) {
                                var results = res.data.dataStore;
                                return {
                                    depositSingleToken: BigNumber.from(results.depositSingleToken.returnValues[0]),
                                    depositMultiToken: BigNumber.from(results.depositMultiToken.returnValues[0]),
                                    withdrawalMultiToken: BigNumber.from(results.withdrawalMultiToken.returnValues[0]),
                                    singleSwap: BigNumber.from(results.singleSwap.returnValues[0]),
                                    swapOrder: BigNumber.from(results.swapOrder.returnValues[0]),
                                    increaseOrder: BigNumber.from(results.increaseOrder.returnValues[0]),
                                    decreaseOrder: BigNumber.from(results.decreaseOrder.returnValues[0]),
                                    estimatedFeeBaseGasLimit: BigNumber.from(results.estimatedFeeBaseGasLimit.returnValues[0]),
                                    estimatedFeeMultiplierFactor: BigNumber.from(results.estimatedFeeMultiplierFactor.returnValues[0]),
                                };
                            },
                        })];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, {
                                gasLimits: data,
                            }];
                }
            });
        }); };
        _this.getPositionsConstants = function () { return __awaiter(_this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, runMulticall(this.chainId, 'usePositionsConstants', this.library, {
                            key: [],
                            refreshInterval: 60000,
                            request: {
                                dataStore: {
                                    contractAddress: getContract({ chainId: this.chainId, name: 'DataStore' }) || '',
                                    abi: DataStoreAbi,
                                    calls: {
                                        minCollateralUsd: {
                                            methodName: 'getUint',
                                            params: [MIN_COLLATERAL_USD_KEY],
                                        },
                                        minPositionSizeUsd: {
                                            methodName: 'getUint',
                                            params: [MIN_POSITION_SIZE_USD_KEY],
                                        },
                                    },
                                },
                            },
                            parseResponse: function (res) {
                                return {
                                    minCollateralUsd: BigNumber.from(res.data.dataStore.minCollateralUsd.returnValues[0]),
                                    minPositionSizeUsd: BigNumber.from(res.data.dataStore.minPositionSizeUsd.returnValues[0]),
                                };
                            },
                        })];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, (data || {})];
                }
            });
        }); };
        _this.getGasPrice = function () { return __awaiter(_this, void 0, void 0, function () {
            var provider, executionFeeBufferBps, gasPrice, buffer, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        provider = this.library;
                        executionFeeBufferBps = '1000';
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, provider.getGasPrice()
                            // if (executionFeeConfig.shouldUseMaxPriorityFeePerGas) {
                            //   const feeData = await provider.getFeeData()
                            //   // the wallet provider might not return maxPriorityFeePerGas in feeData
                            //   // in which case we should fallback to the usual getGasPrice flow handled below
                            //   if (feeData && feeData.maxPriorityFeePerGas) {
                            //     gasPrice = gasPrice.add(feeData.maxPriorityFeePerGas)
                            //   }
                            // }
                            // if (settings.executionFeeBufferBps) {
                            //   const buffer = gasPrice.mul(settings.executionFeeBufferBps).div(BASIS_POINTS_DIVISOR)
                            //   gasPrice = gasPrice.add(buffer)
                            // }
                            // const premium = GAS_PRICE_ADJUSTMENT_MAP[chainId] || BigNumber.from(0)
                        ];
                    case 2:
                        gasPrice = _a.sent();
                        // if (executionFeeConfig.shouldUseMaxPriorityFeePerGas) {
                        //   const feeData = await provider.getFeeData()
                        //   // the wallet provider might not return maxPriorityFeePerGas in feeData
                        //   // in which case we should fallback to the usual getGasPrice flow handled below
                        //   if (feeData && feeData.maxPriorityFeePerGas) {
                        //     gasPrice = gasPrice.add(feeData.maxPriorityFeePerGas)
                        //   }
                        // }
                        // if (settings.executionFeeBufferBps) {
                        //   const buffer = gasPrice.mul(settings.executionFeeBufferBps).div(BASIS_POINTS_DIVISOR)
                        //   gasPrice = gasPrice.add(buffer)
                        // }
                        // const premium = GAS_PRICE_ADJUSTMENT_MAP[chainId] || BigNumber.from(0)
                        if (executionFeeBufferBps) {
                            buffer = gasPrice.mul(executionFeeBufferBps).div(BASIS_POINTS_DIVISOR);
                            gasPrice = gasPrice.add(buffer);
                        }
                        return [2 /*return*/, gasPrice];
                    case 3:
                        e_2 = _a.sent();
                        // eslint-disable-next-line no-console
                        console.error(e_2);
                        return [2 /*return*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        _this.getOrdersInfo = function (_a) {
            var account = _a.account, marketsInfoData = _a.marketsInfoData, tokensData = _a.tokensData;
            return __awaiter(_this, void 0, void 0, function () {
                var ordersData, wrappedToken, ordersInfoData;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, this.getOrders({ account: account })];
                        case 1:
                            ordersData = (_b.sent()).ordersData;
                            wrappedToken = getWrappedToken(this.chainId);
                            if (!marketsInfoData || !ordersData || !tokensData) {
                                return [2 /*return*/, {
                                        isLoading: true,
                                    }];
                            }
                            ordersInfoData = Object.keys(ordersData)
                                .filter(function (orderKey) { return isVisibleOrder(ordersData[orderKey].orderType); })
                                .reduce(function (acc, orderKey) {
                                var order = getByKey(ordersData, orderKey);
                                var orderInfo = getOrderInfo(marketsInfoData, tokensData, wrappedToken, order);
                                if (!orderInfo) {
                                    // eslint-disable-next-line no-console
                                    console.warn("OrderInfo parsing error", JSON.stringify(order));
                                    return acc;
                                }
                                acc[orderKey] = orderInfo;
                                return acc;
                            }, {});
                            return [2 /*return*/, {
                                    ordersInfoData: ordersInfoData,
                                    isLoading: false,
                                }];
                    }
                });
            });
        };
        _this.getOrders = function (_a) {
            var account = _a.account;
            return __awaiter(_this, void 0, void 0, function () {
                var data;
                var _this = this;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, runMulticall(this.chainId, 'useOrdersData', this.library, {
                                key: account ? [account] : null,
                                request: function () { return ({
                                    dataStore: {
                                        contractAddress: getContract({ chainId: _this.chainId, name: 'DataStore' }) || '',
                                        abi: DataStoreAbi,
                                        calls: {
                                            count: {
                                                methodName: 'getBytes32Count',
                                                params: [accountOrderListKey(account)],
                                            },
                                            keys: {
                                                methodName: 'getBytes32ValuesAt',
                                                params: [accountOrderListKey(account), 0, DEFAULT_COUNT],
                                            },
                                        },
                                    },
                                    reader: {
                                        contractAddress: getContract({ chainId: _this.chainId, name: 'SyntheticsReader' }) || '',
                                        abi: SyntheticsReaderAbi,
                                        calls: {
                                            orders: {
                                                methodName: 'getAccountOrders',
                                                params: [
                                                    getContract({ chainId: _this.chainId, name: 'DataStore' }),
                                                    account,
                                                    0,
                                                    DEFAULT_COUNT,
                                                ],
                                            },
                                        },
                                    },
                                }); },
                                parseResponse: function (res) {
                                    var count = Number(res.data.dataStore.count.returnValues[0]);
                                    var orderKeys = res.data.dataStore.keys.returnValues;
                                    var orders = res.data.reader.orders.returnValues;
                                    return {
                                        count: count,
                                        ordersData: orders.reduce(function (acc, order, i) {
                                            var key = orderKeys[i];
                                            var data = order.data;
                                            acc[key] = {
                                                key: key,
                                                account: order.addresses.account,
                                                receiver: order.addresses.receiver,
                                                callbackContract: order.addresses.callbackContract,
                                                marketAddress: order.addresses.market,
                                                initialCollateralTokenAddress: order.addresses.initialCollateralToken,
                                                swapPath: order.addresses.swapPath,
                                                sizeDeltaUsd: BigNumber.from(order.numbers.sizeDeltaUsd),
                                                initialCollateralDeltaAmount: BigNumber.from(order.numbers.initialCollateralDeltaAmount),
                                                contractTriggerPrice: BigNumber.from(order.numbers.triggerPrice),
                                                contractAcceptablePrice: BigNumber.from(order.numbers.acceptablePrice),
                                                executionFee: BigNumber.from(order.numbers.executionFee),
                                                callbackGasLimit: BigNumber.from(order.numbers.callbackGasLimit),
                                                minOutputAmount: BigNumber.from(order.numbers.minOutputAmount),
                                                updatedAtBlock: BigNumber.from(order.numbers.updatedAtBlock),
                                                isLong: order.flags.isLong,
                                                shouldUnwrapNativeToken: order.flags.shouldUnwrapNativeToken,
                                                isFrozen: order.flags.isFrozen,
                                                orderType: order.numbers.orderType,
                                                decreasePositionSwapType: order.numbers.decreasePositionSwapType,
                                                data: data,
                                            };
                                            return acc;
                                        }, {}),
                                    };
                                },
                            })];
                        case 1:
                            data = (_b.sent()).data;
                            return [2 /*return*/, {
                                    ordersData: data === null || data === void 0 ? void 0 : data.ordersData,
                                }];
                    }
                });
            });
        };
        return _this;
    }
    return GMXHelper;
}(Config));
export { GMXHelper };
